import { escapeAttr, escapeHtml, linkAttrs, } from "@emkit/builder-core";
export const CTA_BANNER_DEFAULTS = {
    title: "Ready to ship your next page?",
    subtitle: "Start for free. No credit card required.",
    primaryCtaLabel: "Start building",
    primaryCtaHref: "#",
    primaryCtaVariant: "primary",
    secondaryCtaLabel: "Read the docs",
    secondaryCtaHref: "#",
    secondaryCtaVariant: "ghost",
    layout: "centered",
    size: "md",
    bgStyle: "solid",
    background: "#111827",
    backgroundEnd: "#374151",
    textColor: "#ffffff",
    accent: "#ffffff",
    radius: 16,
};
const SIZES = {
    sm: { paddingY: 32, paddingX: 24, title: 22, subtitle: 15 },
    md: { paddingY: 48, paddingX: 40, title: 30, subtitle: 16 },
    lg: { paddingY: 64, paddingX: 48, title: 38, subtitle: 18 },
};
function button(label, href, variant, accent, text, target) {
    let colours;
    if (variant === "primary") {
        colours = `background:${accent};color:#111827;border:1px solid ${accent}`;
    }
    else if (variant === "secondary") {
        colours = `background:transparent;color:${text};border:1px solid ${text}`;
    }
    else {
        colours = `background:transparent;color:${text};border:1px solid transparent;text-decoration:underline`;
    }
    const style = [
        "display:inline-flex",
        "align-items:center",
        "justify-content:center",
        "padding:12px 22px",
        "border-radius:8px",
        "font-weight:500",
        "font-size:15px",
        "text-decoration:none",
        colours,
    ].join(";");
    return `<a href="${escapeAttr(href)}"${linkAttrs(href, target)} class="emk-cta-btn" style="${style}">${escapeHtml(label)}</a>`;
}
export const ctaBannerWidget = {
    type: "cta-banner",
    defaultProps: CTA_BANNER_DEFAULTS,
    renderHtml(props) {
        const size = SIZES[props.size ?? "md"];
        const layout = props.layout ?? "centered";
        const bg = props.background ?? "#111827";
        const bgEnd = props.backgroundEnd ?? "#374151";
        const bgStyle = props.bgStyle ?? "solid";
        const text = props.textColor ?? "#ffffff";
        const accent = props.accent ?? "#ffffff";
        const radius = props.radius ?? 16;
        const backgroundCss = bgStyle === "gradient"
            ? `background-image:linear-gradient(135deg,${bg},${bgEnd})`
            : `background:${bg}`;
        const ctas = [
            button(props.primaryCtaLabel, props.primaryCtaHref, props.primaryCtaVariant ?? "primary", accent, text, props.primaryCtaTarget),
            props.secondaryCtaLabel && props.secondaryCtaHref
                ? button(props.secondaryCtaLabel, props.secondaryCtaHref, props.secondaryCtaVariant ?? "ghost", accent, text, props.secondaryCtaTarget)
                : "",
        ]
            .filter(Boolean)
            .join("");
        const titleEl = `<h2 style="margin:0;font-size:${size.title}px;font-weight:700;line-height:1.2;letter-spacing:-0.01em;color:${text}">${escapeHtml(props.title)}</h2>`;
        const subtitleEl = props.subtitle
            ? `<p style="margin:8px 0 0;font-size:${size.subtitle}px;line-height:1.55;color:${text};opacity:0.8">${escapeHtml(props.subtitle)}</p>`
            : "";
        const ctaGroup = `<div class="emk-cta-btns" style="display:flex;gap:12px;flex-wrap:wrap;${layout === "centered" ? "justify-content:center" : ""}">${ctas}</div>`;
        const wrapStyle = [
            backgroundCss,
            `color:${text}`,
            `padding:${size.paddingY}px ${size.paddingX}px`,
            `border-radius:${radius}px`,
            "font-family:inherit",
            "max-width:1200px",
            "margin:0 auto",
        ].join(";");
        if (layout === "split") {
            return `<div class="emk-cta-banner emk-cta-banner--split" style="${wrapStyle}"><div style="display:flex;align-items:center;justify-content:space-between;gap:32px;flex-wrap:wrap"><div style="flex:1;min-width:260px">${titleEl}${subtitleEl}</div>${ctaGroup}</div></div>`;
        }
        return `<div class="emk-cta-banner emk-cta-banner--centered" style="${wrapStyle}"><div style="max-width:640px;margin:0 auto;text-align:center;display:flex;flex-direction:column;align-items:center;gap:24px"><div>${titleEl}${subtitleEl}</div>${ctaGroup}</div></div>`;
    },
};
//# sourceMappingURL=cta-banner.js.map